var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"cf-c-tabs__item",attrs:{"active-class":"cf-is-active","to":_vm.to}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }